// Import our custom CSS
 import '../scss/style.scss'
//import '../scss/menu.scss'
// import '../scss/nouislider.less'

 import "bootstrap-icons/font/bootstrap-icons.scss"
// Import all of Bootstrap's JS


//import * as bootstrap from 'bootstrap'

//mask 
import Inputmask from "inputmask";
var selector = document.getElementById("selector");

var im = new Inputmask("+7(999)-999-9999");
if(selector){
  im.mask(selector);
}
//mask 

 
//zoom 
import Drift from 'drift-zoom';
var ImageZoom = document.querySelectorAll("img.image-zoom");
var ImageZoomPane = document.querySelectorAll("div.image-zoom-pane");
if(ImageZoom){
  var i=0;
  for (var element of ImageZoom) {
    console.log(element)
    new Drift(element, {
      paneContainer: ImageZoomPane[i]
    });
    i++;
  } 
} 
//zoom 
//табы фото
document.addEventListener('DOMContentLoaded', function () {
  // Получаем все кнопки табов
  var tabButtons = document.querySelectorAll('.product-gallery-thumblist-item'); 
if(tabButtons){
  // Назначаем обработчик события клика для каждой кнопки
  tabButtons.forEach(function (e) {
      e.addEventListener('click', function () { 
          // Очищаем активный класс у всех вкладок
          document.querySelectorAll('.product-gallery-preview-item').forEach(function (tab) {
              tab.classList.remove('active');
          });
          tabButtons.forEach(function (tab) {
            tab.classList.remove('active');
        });
          // Получаем значение атрибута data-tab для определения целевой вкладки
          var targetTabId = e.getAttribute('data-tab');

          e.classList.add('active');
          // Добавляем активный класс для выбранной вкладки
          document.getElementById(targetTabId).classList.add('active'); 
      });
  });
}
});
//табы фото

 
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})


let lastScrollTop = 0;
const menu = document.getElementById('menu-fix');

window.addEventListener("scroll", function(){
   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
   //console.log(scrollTop);
   if (scrollTop > lastScrollTop){ // скроллим вниз
      menu.style.top = "-140px"; // скрываем меню 
   } else { // скроллим вверх
      menu.style.top = "0"; // показываем меню 
   }
   if(scrollTop>200){
    menu.classList.add('menu_bg'); 
   }else{
      menu.classList.remove('menu_bg'); 
   }
   lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для Mobile Safari
}, false);


//slick
import $ from 'jquery';
import 'slick-carousel'; 
$("#slider").slick()

const button = document.getElementById("toggle-button");
const hiddenItems = document.querySelectorAll(".hidden");

button.addEventListener("click", function () {
    hiddenItems.forEach(item => {
        item.classList.toggle("hidden");
    });

    if (hiddenItems[0].classList.contains("hidden")) {
        button.textContent = "Показать больше";
    } else {
        button.textContent = "Скрыть";
    }
});
 
//window.bootstrap = bootstrap;
